// API + storefront market bootstrap (market list: GET /api/markets → market_config.py)
import { initMarketsFromPayload, detectUserMarket } from './marketConfig';
import brand from './config/brand.json';

// API Configuration
// Change this to your deployed API URL when ready
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Shopify Configuration
// Build store URL from domain
const shopifyDomain = process.env.REACT_APP_SHOPIFY_DOMAIN || 'your-store.myshopify.com';
export const SHOPIFY_STORE_URL = shopifyDomain.startsWith('http')
  ? shopifyDomain
  : `https://${shopifyDomain}`;

// Note: Custom blend variant IDs are now returned by the API
// via /blends/evaluate endpoint (tier pricing system)
// No need to configure them in frontend environment variables

// Bulk Ingredients Page URL (for single ingredient purchases)
export const BULK_INGREDIENTS_URL =
  process.env.REACT_APP_BULK_INGREDIENTS_URL || '/collections/bulk-ingredients';

/** Must match Shopify `content.product_badge_sold_out` (e.g. locales/en.default.json). */
export const PRODUCT_BADGE_SOLD_OUT_LABEL = 'Sold out';

// Brand Configuration (canonical values: herbal-tea-builder/src/config/brand.json)
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || brand.name;
export const BRAND_LABEL_TAGLINE =
  process.env.REACT_APP_BRAND_LABEL_TAGLINE || brand.labelTagline;
export const BRAND_COLORS = {
  primary: '#4A6B4D',
  secondary: '#7A9B7E',
  accent: '#A8C5A3',
  background: '#FDFEF9',
  text: '#2C3E2E',
};

/** Resolved after initMarketsConfig() runs */
let userMarket = 'US';

/**
 * Fetch /api/markets and run detection. Call once before rendering the app.
 */
export async function initMarketsConfig() {
  try {
    const res = await fetch(`${API_BASE_URL}/api/markets`);
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const payload = await res.json();
    initMarketsFromPayload(payload);
  } catch (e) {
    console.warn(
      '[config] Could not load /api/markets; using default market US only.',
      e
    );
    initMarketsFromPayload(null);
  }
  userMarket = detectUserMarket();
}

/**
 * Storefront market sent to the API (US / CA / IN, …).
 */
export function getUserMarket() {
  return userMarket;
}
